import {Sprint} from '../models/sprint';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

export class SprintsRepository {
    private subject: BehaviorSubject<Sprint[]>;

    constructor(seed: Sprint[]) {
        this.subject = new BehaviorSubject(seed);
    }

    public byEmployeeId(employeeId: number): Observable<Sprint[]> {
        return this.subject.pipe(map((sprints) => sprints.filter((sprint) => sprint.employee_id === employeeId)));
    }

    public streamById(sprintId: number): Observable<Sprint | null> {
        return this.subject.pipe(
            map(() => this.find(sprintId)),
            distinctUntilChanged(),
        );
    }

    public findByEmployeeId(employeeId: number) {
        return this.subject.value.filter((sprint) => sprint.employee_id === employeeId);
    }

    public find(sprintId: number): Sprint | null {
        return this.subject.value.find((sprint) => sprint.id === sprintId) || null;
    }

    public destroy(sprintId: number) {
        this.subject.next([...this.subject.value.filter((s) => s.id !== sprintId)]);
    }

    public store(sprint: Sprint) {
        this.subject.next([...this.subject.value.filter((s) => s.id !== sprint.id), sprint]);
    }

    public storeMany(updatedSprints: Sprint[]) {
        const otherSprints = this.subject.value.filter(
            (s) => !updatedSprints.some((updatedSprint) => updatedSprint.id === s.id),
        );
        this.subject.next([...otherSprints, ...updatedSprints]);
    }

    public replace(sprints: Sprint[]) {
        this.subject.next(sprints);
    }

    public findMany(sprintIds: number[]): Sprint[] {
        return this.subject.value.filter((sprint) => sprintIds.indexOf(sprint.id) !== -1);
    }

    public destroyMany(sprintIds: number[]) {
        this.subject.next([...this.subject.value.filter((sprint) => sprintIds.indexOf(sprint.id) === -1)]);
    }

    public findByMoneybirdContactId(moneybirdContactId: number) {
        return this.subject.value.filter((sprint) => sprint.estimate.moneybird_contact_id === moneybirdContactId);
    }
}
